import { Spinner } from '@change/ds-core-ui';

export const Loading = <Spinner className="mx-auto my-64" />;
